import defaultTokens, {
  type FormBaseTokens,
} from '@agria/theme/src/components/form/base/tokens';
import { colors } from '@agria/theme/src/styles/tokens';

const tokens: FormBaseTokens = {
  ...defaultTokens,
  tickFill: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23000' fill-rule='evenodd' d='M8.41239 16.3009 19.8874 4.82599c.4346-.43465 1.1649-.43465 1.5995 0 .4347.43466.4347 1.16485 0 1.59951L8.41239 19.5l-5.91135-5.9113c-.43466-.4347-.43466-1.1649 0-1.5996.43466-.4346 1.16488-.4346 1.59954 0l4.31181 4.3118Z' clip-rule='evenodd'/%3E%3C/svg%3E`,
  tickWidth: '24px',
  tickHeight: '24px',
  checkedBackground: 'utilityWhite',
  borderRadius: 'large',
  borderSize: '2px',
  size: 'large',
  focusBoxShadow: '0px 0px 0px 2px #FFF, 0px 0px 0px 4px #000',
  focusValidBoxShadow: `${colors.systemFocusValid};`,
  focusInvalidBoxShadow: `${colors.systemFocusInvalid};`,
  formFieldPaddingLarge: 'small',
  formFieldBorderColor: 'brandTwo100',
  placeHolderColor: 'brandTwo80',
  labelBeforeTop: '-4px',
  labelAfterTop: '0px',
  labelTopMargin: '4px',
  borderCorrection: true,
  transition: 'none',
} as const;

export default tokens;
